(() => {
  const root = window.Shopify?.routes?.root || '/';
  const fields = () => [...document.querySelectorAll('[data-cart-note]')];
  const blocks = () => [...document.querySelectorAll('[data-cart-note-block]')];
  let draft = fields()[0]?.value || '';
  let saved = draft;
  let dirty = false;
  let touched = false;
  let timer;
  let queue = Promise.resolve();
  let checkoutBusy = false;
  const approvedForms = new WeakSet();

  function status(key, error = false) {
    for (const block of blocks()) {
      const node = block.querySelector('[data-note-status]');
      node.textContent = block.dataset[key] || '';
      node.dataset.error = String(error);
    }
  }
  function sync(value) {
    draft = value;
    dirty = draft !== saved;
    fields().forEach(field => { field.value = value; });
  }
  async function request(path, body) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root + path, {
        method: body ? 'POST' : 'GET',
        headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
      if (!response.ok) throw new Error('Cart note request failed');
      return await response.json();
    } finally { clearTimeout(timeout); }
  }
  function save(value, verify = false) {
    // Serialize writes so a slower autosave cannot overwrite the checkout note.
    const operation = queue.catch(() => {}).then(async () => {
      const cart = await request('cart/update.js', { note: value });
      if ((cart.note || '') !== value) throw new Error('Cart note was not saved');
      if (verify) {
        const persisted = await request('cart.js');
        if ((persisted.note || '') !== value) throw new Error('Cart note verification failed');
      }
      saved = value;
      dirty = draft !== saved;
      return cart;
    });
    queue = operation;
    return operation;
  }
  async function autosave() {
    if (checkoutBusy || !dirty) return;
    status('noteSaving');
    try {
      await save(draft);
      if (!checkoutBusy) status(dirty ? 'notePending' : draft ? 'noteSaved' : 'noteSkipped');
    } catch { if (!checkoutBusy) status('noteError', true); }
  }
  function enhance() {
    document.querySelectorAll('[data-note-skip]').forEach(button => { button.hidden = false; });
  }
  document.addEventListener('click', event => {
    if (checkoutBusy && event.target.closest('.cart-remove, #CartPanel [data-key], [data-note-skip]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-cart-note]') || checkoutBusy) return;
    touched = true;
    sync(event.target.value);
    status('notePending');
    clearTimeout(timer);
    timer = setTimeout(autosave, 450);
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-note-skip]');
    if (!button || checkoutBusy) return;
    touched = true;
    clearTimeout(timer);
    sync('');
    // Save the empty note too, clearing any grinding request saved earlier.
    status('noteSaving');
    save('', true).then(() => {
      if (!checkoutBusy) status(dirty ? 'notePending' : 'noteSkipped');
    }).catch(() => { if (!checkoutBusy) status('noteError', true); });
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('#CartPanel .cart-panel__links a');
    if (!link || !dirty || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    // An immediate "View cart" click must not discard the drawer's pending edit.
    event.preventDefault();
    if (checkoutBusy) return;
    checkoutBusy = true;
    clearTimeout(timer);
    fields().forEach(field => { field.readOnly = true; });
    status('noteSaving');
    try {
      await save(draft, true);
      window.location.assign(link.href);
    } catch { status('noteError', true); }
    finally {
      checkoutBusy = false;
      fields().forEach(field => { field.readOnly = false; });
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    const field = form.querySelector?.('[data-cart-note]');
    if (!field) return;
    if (approvedForms.has(form)) { approvedForms.delete(form); return; }
    const button = event.submitter;
    if (button?.name !== 'checkout') return;
    event.preventDefault();
    if (checkoutBusy) return;
    checkoutBusy = true;
    clearTimeout(timer);
    sync(field.value);
    const value = draft;
    const controls = [...document.querySelectorAll('[data-note-skip], form:has([data-cart-note]) button[type="submit"], #CartPanel [data-key]')];
    const previous = controls.map(control => [control, control.disabled]);
    controls.forEach(control => { control.disabled = true; });
    fields().forEach(node => { node.readOnly = true; });
    form.setAttribute('aria-busy', 'true');
    status('noteCheckout');
    let success = false;
    try {
      await save(value, true);
      success = true;
      status(value ? 'noteSaved' : 'noteSkipped');
    } catch { status('noteError', true); }
    finally {
      checkoutBusy = false;
      previous.forEach(([control, disabled]) => { control.disabled = disabled; });
      fields().forEach(node => { node.readOnly = false; });
      form.removeAttribute('aria-busy');
    }
    if (success) {
      // Keep Shopify's native cart form submission, quantities and locale handling.
      approvedForms.add(form);
      form.requestSubmit(button);
    } else { field.focus(); }
  }, true);
  window.CoffeaCartNotes = {
    update(cart) {
      // Quantity changes and cart reopens must not replace an unsaved edit.
      if (!touched && !dirty && !checkoutBusy) { saved = cart.note || ''; sync(saved); }
      else fields().forEach(field => { field.value = draft; });
      enhance();
    },
  };
  enhance();
})();
